import { render, staticRenderFns } from "./BrigadeConsultateJob.vue?vue&type=template&id=1f31f1ed&"
import script from "./BrigadeConsultateJob.vue?vue&type=script&lang=js&"
export * from "./BrigadeConsultateJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports